const MEMBER_WALLET_REQUEST = 'MEMBER_WALLET_REQUEST';
const MEMBER_WALLET_SUCCESS = 'MEMBER_WALLET_SUCCESS';
const MEMBER_WALLET_ERROR = 'MEMBER_WALLET_ERROR';

import {MEMBER_VIRTUAL_GIFT_DELETE_SUCCESS} from './member';

import * as backend from 'backend-helpers/memberWallet';

const initState = {
    history: {
        list: [],
        totals: {
            credit: 0,
            debit: 0
        }
    },
    virtualGifts: {
        list: [],
    }
};

export default function memberWallet(state = initState, action) {
    if (action.type === MEMBER_WALLET_SUCCESS) {
        let {history, virtualGifts, amountAvailable} = action.result;

        return {
            ...state,
            history,
            virtualGifts,
            amountAvailable
        }
    }

    if (action.type === MEMBER_VIRTUAL_GIFT_DELETE_SUCCESS) {
        return {
            ...state,
            virtualGifts: {
                ...state.virtualGifts,
                list: state.virtualGifts.list.filter((virtualGift) => virtualGift.id !== action.id)
            }
        }
    }


    return state;
}

export function getMemberWallet(page = 1) {
    return {
        types: [MEMBER_WALLET_REQUEST, MEMBER_WALLET_SUCCESS, MEMBER_WALLET_ERROR],
        promise: backend.getMemberWallet({page})
    }
}


// WEBPACK FOOTER //
// ./src/reducers/memberWallet.js